(function () {
  'use strict';

  function moneyFromCents(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 2,
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function initializeProduct(root) {
    var form = root.querySelector('form[data-ms-product-form]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var quantityInput = form && form.querySelector('input[name="quantity"]');
    var submitLabel = form && form.querySelector('[data-ms-submit-label]');
    var buyboxPrice = root.querySelector('[data-ms-buybox-price]');
    var statusChip = root.querySelector('[data-ms-status-chip]');
    var comparePrice = root.querySelector('[data-ms-compare-price]');
    var sticky = document.querySelector('[data-ms-sticky-buy]');
    var stickyPrice = sticky && sticky.querySelector('[data-ms-sticky-price]');
    var currency = root.getAttribute('data-currency') || 'USD';
    var buttonLabel = root.getAttribute('data-button-label') || 'Add to cart';
    var primaryButton = form && form.querySelector('[type="submit"]');
    var stickyButton = sticky && sticky.querySelector('[data-ms-sticky-submit]');

    root.querySelectorAll('[data-ms-bundle]').forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        root.querySelectorAll('[data-ms-bundle]').forEach(function (item) {
          var active = item === bundle;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (variantInput && bundle.dataset.variantId) variantInput.value = bundle.dataset.variantId;
        if (quantityInput) quantityInput.value = bundle.dataset.quantity || '1';

        var formatted = bundle.dataset.priceLabel || moneyFromCents(bundle.dataset.price, currency);
        var compareLabel = bundle.dataset.compareLabel || '';
        var available = bundle.dataset.available !== 'false';
        if (primaryButton) primaryButton.disabled = !available;
        if (stickyButton) {
          stickyButton.disabled = !available;
          stickyButton.textContent = available ? buttonLabel : 'Sold out';
        }
        if (submitLabel) submitLabel.textContent = available ? buttonLabel + ' - ' + formatted : 'Sold out';
        if (buyboxPrice) buyboxPrice.textContent = formatted;
        if (statusChip) {
          var savingsLabel = bundle.dataset.savingsLabel || '';
          statusChip.textContent = savingsLabel;
          statusChip.hidden = !savingsLabel;
        }
        if (comparePrice) {
          comparePrice.textContent = compareLabel;
          comparePrice.hidden = !compareLabel;
        }
        if (stickyPrice) stickyPrice.textContent = formatted;
      });
    });

    var gallery = root.querySelector('[data-ms-gallery]');
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-ms-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ms-thumb]'));
    var galleryCurrent = root.querySelector('[data-ms-gallery-current]');

    function activateMedia(index) {
      if (!mediaItems.length) return;
      var normalized = (index + mediaItems.length) % mediaItems.length;
      var activeMedia = mediaItems[normalized];
      var target = activeMedia.getAttribute('data-media-id');

      mediaItems.forEach(function (media, mediaIndex) {
        var active = mediaIndex === normalized;
        media.classList.toggle('is-active', active);
        media.hidden = !active;
        media.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-target') === target;
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.setAttribute('tabindex', active ? '0' : '-1');
        if (active && thumb.parentElement) {
          thumb.parentElement.scrollTo({
            left: Math.max(0, thumb.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2),
            behavior: 'smooth',
          });
        }
      });

      if (galleryCurrent) galleryCurrent.textContent = String(normalized + 1);
      if (gallery) gallery.dataset.activeIndex = String(normalized);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = thumb.getAttribute('data-target');
        var index = mediaItems.findIndex(function (media) {
          return media.getAttribute('data-media-id') === target;
        });
        if (index >= 0) activateMedia(index);
      });
      thumb.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var currentIndex = thumbs.indexOf(thumb);
        var targetIndex = currentIndex;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = thumbs.length - 1;
        if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
        if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % thumbs.length;
        activateMedia(targetIndex);
        thumbs[targetIndex].focus();
      });
    });

    var previous = root.querySelector('[data-ms-gallery-prev]');
    var next = root.querySelector('[data-ms-gallery-next]');
    if (previous) previous.addEventListener('click', function () {
      activateMedia(Number(gallery && gallery.dataset.activeIndex || 0) - 1);
    });
    if (next) next.addEventListener('click', function () {
      activateMedia(Number(gallery && gallery.dataset.activeIndex || 0) + 1);
    });

    if (gallery) {
      var touchStartX = 0;
      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        activateMedia(Number(gallery.dataset.activeIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
      });
      gallery.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 45) return;
        activateMedia(Number(gallery.dataset.activeIndex || 0) + (distance < 0 ? 1 : -1));
      }, { passive: true });
      activateMedia(0);
    }

    if (sticky && form) {
      var primaryVisible = true;
      var footerVisible = false;

      function updateSticky() {
        var shouldShow = !primaryVisible && !footerVisible && window.scrollY > 240;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.classList.toggle('is-footer-visible', footerVisible);
      }

      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          form.requestSubmit();
        });
      }

      if ('IntersectionObserver' in window && primaryButton) {
        var buttonObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            primaryVisible = entry.isIntersecting;
            updateSticky();
          });
        }, { threshold: 0.05 });
        buttonObserver.observe(primaryButton);

        var footer = document.querySelector('footer');
        if (footer) {
          var footerObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              footerVisible = entry.isIntersecting;
              updateSticky();
            });
          }, { threshold: 0.01 });
          footerObserver.observe(footer);
        }
      }
    }
  }

  function initializeBeforeAfter(root) {
    var range = root.querySelector('[data-ms-before-after-range]');
    if (!range) return;
    range.addEventListener('input', function () {
      root.style.setProperty('--position', range.value + '%');
    });
  }

  function initializeReveals() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.ms-reveal'));
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    items.forEach(function (item) { observer.observe(item); });
  }

  function initializeProofVideos(root) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('.ms-proof-avatars video').forEach(function (video) {
      if (reducedMotion) {
        video.pause();
      } else {
        video.play().catch(function () {});
      }
    });

    root.querySelectorAll('.ms-ugc-card video').forEach(function (video) {
      if (video.dataset.msVideoReady === 'true') return;
      video.dataset.msVideoReady = 'true';
      var media = video.closest('.ms-ugc-card__media');
      var toggle = media && media.querySelector('[data-ms-video-toggle]');
      var userPaused = reducedMotion;

      function updateControl() {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      }

      function playVideo() {
        if (userPaused || reducedMotion) return;
        video.play().then(updateControl).catch(updateControl);
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            video.play().then(updateControl).catch(updateControl);
          } else {
            userPaused = true;
            video.pause();
            updateControl();
          }
        });
      }

      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);

      if (reducedMotion) {
        video.pause();
        updateControl();
        return;
      }

      if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) playVideo();
            else video.pause();
          });
        }, { threshold: 0.35 });
        videoObserver.observe(video);
      } else {
        playVideo();
      }
    });
  }

  function scrollToPurchase(event) {
    var link = event.target.closest('[data-ms-scroll-buy]');
    if (!link) return;
    var target = document.querySelector('#msteamer-buy');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function initialize() {
    document.querySelectorAll('[data-ms-product]').forEach(initializeProduct);
    document.querySelectorAll('[data-ms-before-after]').forEach(initializeBeforeAfter);
    initializeProofVideos(document);
    initializeReveals();
    document.addEventListener('click', scrollToPurchase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var product = event.target.querySelector('[data-ms-product]');
    var beforeAfter = event.target.querySelector('[data-ms-before-after]');
    if (product) initializeProduct(product);
    if (beforeAfter) initializeBeforeAfter(beforeAfter);
    initializeProofVideos(event.target);
  });
})();
